import React from 'react';
import { Box, Chip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const severityColor = (level) => {
  if (!level) return 'default';
  const l = String(level).toLowerCase();
  if (l === 'error' || l === 'critical') return 'error';
  if (l === 'warning') return 'warning';
  if (l === 'info') return 'info';
  return 'default';
};

export default function LogViewer({ logs = [] }) {
  const columns = [
    { field: 'createdAt', headerName: 'Timestamp', width: 180, valueFormatter: (p) => p.value ? new Date(p.value).toLocaleString() : '—' },
    { field: 'action', headerName: 'Action', flex: 1 },
    { field: 'userName', headerName: 'User', width: 160, valueGetter: (p) => p.row?.userName || p.row?.user?.name || '—' },
    { field: 'details', headerName: 'Details', flex: 1.5 },
    { field: 'severity', headerName: 'Severity', width: 110, renderCell: (p) => (
      <Chip label={p.value || 'info'} color={severityColor(p.value)} size="small" />
    )},
    { field: 'ipAddress', headerName: 'IP', width: 130 },
  ];

  return (
    <Box sx={{ height: 600, width: '100%' }}>
      <DataGrid
        rows={logs}
        columns={columns}
        getRowId={(row) => row.id || Math.random()}
        disableRowSelectionOnClick
        pageSizeOptions={[10, 25, 50, 100]}
        initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
      />
    </Box>
  );
}
